// Flag/positional parsing for the `context` command.

export function parseArgs(args: string[]): { flags: Record<string, string | boolean>; positional: string[] } {
  const flags: Record<string, string | boolean> = {}
  const positional: string[] = []
  for (let i = 0; i < args.length; i++) {
    if (args[i].startsWith('--')) {
      const key = args[i].slice(2)
      const next = args[i + 1]
      if (next !== undefined && !next.startsWith('--')) {
        flags[key] = next
        i++
      } else {
        flags[key] = true
      }
    } else {
      positional.push(args[i])
    }
  }
  return { flags, positional }
}

// Collect every occurrence of a flag's value across `args`, in order.
// `parseArgs` keeps only the LAST value of a repeated flag, which silently
// drops `--pattern a --pattern b` to just `b`. Use this for flags that
// must support repetition (--pattern, --add-pattern, --remove-pattern,
// --gotcha, --decision, --invariant, --check).
export function collectMulti(args: string[], names: string[]): string[] {
  const out: string[] = []
  for (let i = 0; i < args.length - 1; i++) {
    const a = args[i]
    const b = args[i + 1]
    if (b === undefined || b.startsWith('--')) continue
    if (names.includes(a)) out.push(b)
  }
  return out
}
